export default function FooterList({ options, title }: { options: any, title: any }) {
    return (
        <div className="space-y-3 text-xs lg:text-sm text-left md:text-center xl:text-left">
            <p className="font-bold">{title}</p>
            {
                options.map((option: any) => <p key={option.title}><a href={option.link}>{option.title}</a></p>)
            }
        </div>
    )
}